import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';


class NotificationsReadTab extends Component {
    static propTypes = {
        notifications: PropTypes.array,
        onClearAll: PropTypes.func,
        onNotificationClick: PropTypes.func,
    };

    constructor(props) {
        super(props);

        moment.tz.setDefault('Australia/Sydney');
    }

    getNotificationIcon = (notification) => {
        const title = notification.title || '';

        if (title.startsWith('New Ticket:')) {
            return {
                icon: 'fas fa-ticket-alt',
                className: 'ticket',
            };
        }

        if (title.startsWith('New reply from')) {
            return {
                icon: 'fa fa-comments',
                className: 'comment',
            };
        }

        return {
            icon: 'fa fa-bell',
            className: 'default',
        };
    };

    formatNotificationTime = (createdAt) => {
        if (!createdAt) {
            return '';
        }

        const created = moment(createdAt);
        const now = moment();

        const minutes = now.diff(created, 'minutes');
        const hours = now.diff(created, 'hours');
        const days = now.diff(created, 'days');

        if (minutes < 1) {
            return 'Just now';
        }

        if (minutes < 60) {
            return `${minutes} min${minutes === 1 ? '' : 's'} ago`;
        }

        if (hours < 24) {
            return `${hours} hr${hours === 1 ? '' : 's'} ago`;
        }

        if (days === 1) {
            return 'Yesterday';
        }

        if (days < 7) {
            return `${days} days ago`;
        }

        return created.format('D MMM YYYY');
    };

    handleNotificationClick = (notification) => {
        const {
            onNotificationClick,
        } = this.props;

        if (onNotificationClick) {
            onNotificationClick(notification);
        }
    };

    handleClearAll = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const {
            onClearAll,
            notifications = [],
        } = this.props;

        if (!notifications.length) {
            return;
        }

        if (onClearAll) {
            onClearAll();
        }
    };

    renderNotification = (notification) => {
        const icon = this.getNotificationIcon(notification);

        return (
            <div
                key={notification.id}
                className='notification-card notification-card-read'
                onClick={() => this.handleNotificationClick(notification)}
            >
                <div className='notification-card-icon-wrapper'>
                    <div
                        className={`notification-card-icon ${icon.className}`}
                    >
                        <i
                            className={icon.icon}
                            aria-hidden='true'
                        />
                    </div>
                </div>

                <div className='notification-card-content'>
                    <div className='notification-card-title'>
                        {notification.title}
                    </div>

                    <div className='notification-card-description'>
                        {notification.description}
                    </div>

                    <div className='notification-card-time'>
                        {this.formatNotificationTime(
                            notification.created_at
                        )}
                    </div>

                    <div className='notification-read-status'>
                        <i
                            className='fa fa-check-double'
                            aria-hidden='true'
                        />

                        <span>
                            Read
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const {
            notifications = [],
        } = this.props;

        return (
            <div className='notifications-read-tab'>
                <div className='notifications-actions notifications-read-actions'>
                    <div className='notifications-read-label'>
                        Acknowledged notifications
                    </div>

                    <button
                        type='button'
                        className='mark-all-read-button'
                        onClick={this.handleClearAll}
                        disabled={!notifications.length}
                    >
                        Clear All
                    </button>
                </div>

                {!notifications.length ? (
                    <div className='center-content'>
                        No read notifications
                    </div>
                ) : (
                    <div className='notifications-list'>
                        {notifications.map(
                            this.renderNotification
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default NotificationsReadTab;



// WEBPACK FOOTER //
// ./src/components/Sliders/Notifications/NotificationsReadTab.js